import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from '@/common/localStorages';
import {
  addressSteps,
  contractSteps,
  initialRegisterSteps,
  profilingSteps,
} from '../constants';
import { getNextApiUrl } from '@/utils/next-api';

export const returnRegisterRedirectUrl = (nextStep: string) => {
  let url = '/';
  if (nextStep === 'Exam') {
    url = `/register/exam`;
  } else if (contractSteps.includes(nextStep)) {
    url = `/register/contracts`;
  } else if (nextStep === 'InquiryIdentityStatus') {
    url = `/register/register-status`;
  } else if (nextStep === 'BirthDate') {
    url = `/register/credentials`;
  } else if (nextStep === 'Finish') {
    url = `/`;
  } else if (nextStep === 'Signature') {
    url = `/register/upload-signature`;
  } else if (nextStep === 'RedirectToOldReg') {
    url = getNextApiUrl('auth/complete-register');
  } else if (nextStep === 'Video') {
    url = `/register/videoAuthentication`;
  } else if (addressSteps.includes(nextStep)) {
    url = `/register/address?state=${nextStep}`;
  } else if (nextStep === 'TraceCode') {
    url = `/register/traceCode`;
  } else if (nextStep === 'WaitingEkyc') {
    url = `/register/ekyc-approval`;
  } else if (nextStep === 'NationalCardSerial') {
    url = `/register/national-serial`;
  } else if (profilingSteps.includes(nextStep)) {
    url = `/register/verify-profile`;
  } else if (initialRegisterSteps.includes(nextStep)) {
    url = '/register';
  }
  return url;
};

export const getRequestToken = (): string => {
  return getLocalStorage('regStateRequestToken') || '';
};

export const setRequestToken = (token: string): void => {
  setLocalStorage('regStateRequestToken', token);
};

export const removeRequestToken = () => {
  removeLocalStorage('regStateRequestToken');
};

export const returnExternalSiteEntries = (isOrbisUser: boolean) => {
  const externalSiteEntries = [
    {
      title: 'ورود به مفید اپ',
      imageSrc:
        'https://s3.ir-thr-at1.arvanstorage.com/mofidapp/common/mofid-logo.svg',
      imageAlt: 'مفید اپ',
    },
    {
      title: 'ورود به ایزی تریدر',
      desktopConfig: isOrbisUser ? 'OrbisSite' : 'OnlineSite',
      mobileConfig: isOrbisUser ? 'OrbisMobile' : 'OnlineMobile',

      imageSrc:
        'https://s3.ir-thr-at1.arvanstorage.com/mofidapp/common/easy-trader.svg',
      imageAlt: 'ایزی تریدر',
    },
    {
      title: 'ورود به مفید آنلاین',
      desktopConfig: 'MofidOnline',
      mobileConfig: 'MofidOnlineMobile',
      imageSrc:
        'https://s3.ir-thr-at1.arvanstorage.com/mofidapp/common/mofid-online-logo.svg',
      imageAlt: 'مفید آنلاین',
    },
  ];
  return externalSiteEntries;
};
